module.exports = __webpack_public_path__ + "img/6.ee9e0cb0.png";